import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        checkLogin()
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)



function checkLogin() {
    const data = localStorage.getItem('token_time');
    if (data && new Date() < new Date(data))
        return true;
    else
        return false;
}